import React from "react";

import { StyledSVG } from "../StyledIcon";

export const RestApiIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M6.18744 2.25H5.18744C4.63515 2.25 4.18744 2.69772 4.18744 3.25V6.47903C4.18744 7.31764 3.66426 8.06719 2.87708 8.35636L1.125 9L2.87709 9.64364C3.66426 9.93281 4.18744 10.6824 4.18744 11.521V14.75C4.18744 15.3023 4.63515 15.75 5.18744 15.75H6.18744"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8126 2.25H12.8126C13.3648 2.25 13.8126 2.69772 13.8126 3.25V6.47903C13.8126 7.31764 14.3357 8.06719 15.1229 8.35636L16.875 9L15.1229 9.64364C14.3357 9.93281 13.8126 10.6824 13.8126 11.521V14.75C13.8126 15.3023 13.3648 15.75 12.8126 15.75H11.8126"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
